import { render, staticRenderFns } from "./PricingItem.vue?vue&type=template&id=b135ce96&scoped=true&"
import script from "./PricingItem.vue?vue&type=script&lang=js&"
export * from "./PricingItem.vue?vue&type=script&lang=js&"
import style0 from "./PricingItem.vue?vue&type=style&index=0&id=b135ce96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b135ce96",
  null
  
)

export default component.exports